var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.2,
    height: 16,
    viewBox: "0 0 3.2 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14300"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14299",
    transform: "rotate(-90 8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 987",
    cx: 1.6,
    cy: 1.6,
    r: 1.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14302"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14301",
    transform: "rotate(-90 4.8 4.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 988",
    cx: 1.6,
    cy: 1.6,
    r: 1.6
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14304"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14303",
    transform: "rotate(-90 1.6 1.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 989",
    cx: 1.6,
    cy: 1.6,
    r: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotIcon);
export default __webpack_public_path__ + "static/media/DotIcon.9eba29d0a94d2f3e6f752d9487944697.svg";
export { ForwardRef as ReactComponent };